import { all } from "redux-saga/effects";

import getListRecruitmentRequirementSaga from "./getListRecruitmentRequirement";
import deleteRecruitmentRequirementSaga from "./deleteRecruitmentRequirement";
import approveRecruitmentRequirementSaga from "./approveRecruitmentRequirement";
import rejectRecruitmentRequirementSaga from "./rejectRecruitmentRequirement";
import getDetailRecruitmentSaga from "./getDetailRecruitment";
import createRecruitmentSaga from "./createRecruitment";
import updateRecruitmentSaga from "./updateRecruitment";
import uploadFileSaga from "./uploadFiles";
import getDataBoundarySaga from "./getDataBoundary";
import getDepartmentInfoSaga from "./getDepartmentInfo";
import getListRecruitmentPositionSaga from "./getListRecruitmentPosition";
import getDepartmentPositionDetailSaga from "./getDepartmentPositionDetail";

export default function* recruitmentSaga() {
  yield all([
    getListRecruitmentRequirementSaga(),
    deleteRecruitmentRequirementSaga(),
    approveRecruitmentRequirementSaga(),
    rejectRecruitmentRequirementSaga(),
    getDetailRecruitmentSaga(),
    createRecruitmentSaga(),
    updateRecruitmentSaga(),
    uploadFileSaga(),
    getDataBoundarySaga(),
    getDepartmentInfoSaga(),
    getListRecruitmentPositionSaga(),
    getDepartmentPositionDetailSaga(),
  ]);
}
